export interface IsraelProduct {
  id: string;
  name: string;
  samplePrice: number;
  bulkPrice: number;
  moq: number;
  image: string;
  category: string;
}

export interface IsraelFactory {
  id: string;
  name: string;
  city: string;
  established: number;
  employees: string;
  verified: boolean;
  dropshipping: boolean;
  warehouseCountries?: string[];
  rating: number;
  responseRate: string;
  onTimeDelivery: string;
  productCount: number;
  categories: string[];
  description: string;
  logo: string;
  coverImage: string;
  products: IsraelProduct[];
}

export const israelFactories: IsraelFactory[] = [
  {
    id: "ilf1",
    name: "Tel Aviv AgriTech Solutions",
    city: "Tel Aviv",
    established: 2010,
    employees: "200–500",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Israel", "UAE", "USA", "UK", "Germany", "Netherlands", "Australia"],
    rating: 4.9,
    responseRate: "98%",
    onTimeDelivery: "97%",
    productCount: 1840,
    categories: ["AgriTech", "Irrigation", "Smart Farming"],
    description: "World-leading Israeli agricultural technology manufacturer based in Tel Aviv. Producing precision drip irrigation systems, smart sensors, and agri-tech solutions exported to over 60 countries. Israel's drip irrigation technology is used on 40% of the world's irrigated farmland.",
    logo: "https://public.readdy.ai/ai/img_res/3d4682662aa58ab72afefd7ddc9710f1.jpg",
    coverImage: "https://readdy.ai/api/search-image?query=Israel%20modern%20agritech%20factory%20clean%20room%20precision%20irrigation%20drip%20systems%20production%20workers%20professional%20bright%20green%20technology%20interior&width=800&height=400&seq=ilfc1&orientation=landscape",
    products: [
      {
        id: "ilf1p1",
        name: "Precision Drip Irrigation Kit (1 Acre)",
        samplePrice: 185,
        bulkPrice: 68,
        moq: 10,
        category: "Irrigation",
        image: "https://readdy.ai/api/search-image?query=precision%20drip%20irrigation%20kit%201%20acre%20professional%20agricultural%20equipment%20white%20background%20product%20photography%20Israel%20agritech&width=400&height=400&seq=ilf1p1&orientation=squarish",
      },
      {
        id: "ilf1p2",
        name: "Smart Soil Moisture Sensor Pro",
        samplePrice: 95,
        bulkPrice: 34,
        moq: 20,
        category: "Smart Farming",
        image: "https://readdy.ai/api/search-image?query=smart%20soil%20moisture%20sensor%20pro%20agricultural%20IoT%20device%20white%20background%20product%20photography%20professional%20technology%20Israel&width=400&height=400&seq=ilf1p2&orientation=squarish",
      },
      {
        id: "ilf1p3",
        name: "Automated Greenhouse Controller",
        samplePrice: 320,
        bulkPrice: 118,
        moq: 5,
        category: "AgriTech",
        image: "https://readdy.ai/api/search-image?query=automated%20greenhouse%20controller%20smart%20farming%20device%20white%20background%20product%20photography%20professional%20technology%20Israel%20agritech&width=400&height=400&seq=ilf1p3&orientation=squarish",
      },
    ],
  },
  {
    id: "ilf2",
    name: "Haifa Pharmaceutical & Nutraceuticals",
    city: "Haifa",
    established: 2005,
    employees: "500–1000",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Israel", "USA", "UK", "Germany", "UAE", "Canada", "Australia"],
    rating: 4.9,
    responseRate: "97%",
    onTimeDelivery: "96%",
    productCount: 2200,
    categories: ["Pharmaceuticals", "Nutraceuticals", "Health Supplements"],
    description: "ISO-certified pharmaceutical and nutraceutical manufacturer in Haifa. Producing premium health supplements, vitamins, and natural wellness products. Israel is a global leader in pharmaceutical innovation with world-class R&D facilities and strict quality standards.",
    logo: "https://readdy.ai/api/search-image?query=pharmaceutical%20nutraceutical%20company%20logo%20gold%20health%20emblem%20white%20background%20Haifa%20Israel%20medical%20corporate%20identity%20modern%20minimalist&width=80&height=80&seq=ilfl2&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Haifa%20Israel%20pharmaceutical%20nutraceutical%20factory%20clean%20room%20production%20health%20supplements%20vitamins%20workers%20professional%20bright%20modern%20interior&width=800&height=400&seq=ilfc2&orientation=landscape",
    products: [
      {
        id: "ilf2p1",
        name: "Premium Omega-3 Fish Oil 1000mg (180 caps)",
        samplePrice: 42,
        bulkPrice: 15,
        moq: 50,
        category: "Health Supplements",
        image: "https://readdy.ai/api/search-image?query=premium%20omega%203%20fish%20oil%201000mg%20180%20capsules%20health%20supplement%20white%20background%20product%20photography%20professional%20Israel%20pharmaceutical&width=400&height=400&seq=ilf2p1&orientation=squarish",
      },
      {
        id: "ilf2p2",
        name: "Dead Sea Mineral Multivitamin Complex",
        samplePrice: 55,
        bulkPrice: 20,
        moq: 30,
        category: "Nutraceuticals",
        image: "https://readdy.ai/api/search-image?query=Dead%20Sea%20mineral%20multivitamin%20complex%20health%20supplement%20white%20background%20product%20photography%20professional%20Israel%20nutraceutical&width=400&height=400&seq=ilf2p2&orientation=squarish",
      },
      {
        id: "ilf2p3",
        name: "Probiotic Advanced Formula 50 Billion CFU",
        samplePrice: 68,
        bulkPrice: 24,
        moq: 30,
        category: "Health Supplements",
        image: "https://readdy.ai/api/search-image?query=probiotic%20advanced%20formula%2050%20billion%20CFU%20health%20supplement%20white%20background%20product%20photography%20professional%20pharmaceutical%20Israel&width=400&height=400&seq=ilf2p3&orientation=squarish",
      },
    ],
  },
  {
    id: "ilf3",
    name: "Dead Sea Cosmetics & Beauty Lab",
    city: "Jerusalem",
    established: 2008,
    employees: "100–200",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Israel", "UAE", "USA", "UK", "Germany", "France", "Japan"],
    rating: 4.9,
    responseRate: "98%",
    onTimeDelivery: "97%",
    productCount: 1560,
    categories: ["Cosmetics", "Dead Sea Minerals", "Skincare"],
    description: "Premium Dead Sea cosmetics and skincare manufacturer in Jerusalem. Producing world-famous mineral-rich beauty products using authentic Dead Sea salts and minerals. Exported to luxury retailers in 45+ countries with full private label and dropshipping support.",
    logo: "https://readdy.ai/api/search-image?query=Dead%20Sea%20cosmetics%20beauty%20company%20logo%20gold%20mineral%20crystal%20emblem%20white%20background%20Jerusalem%20Israel%20luxury%20corporate%20identity%20elegant&width=80&height=80&seq=ilfl3&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Jerusalem%20Israel%20Dead%20Sea%20cosmetics%20beauty%20lab%20production%20skincare%20minerals%20luxury%20products%20workers%20professional%20bright%20elegant%20interior&width=800&height=400&seq=ilfc3&orientation=landscape",
    products: [
      {
        id: "ilf3p1",
        name: "Dead Sea Mineral Mud Mask 500ml",
        samplePrice: 48,
        bulkPrice: 17,
        moq: 30,
        category: "Skincare",
        image: "https://readdy.ai/api/search-image?query=Dead%20Sea%20mineral%20mud%20mask%20500ml%20luxury%20skincare%20white%20background%20product%20photography%20premium%20beauty%20Israel%20cosmetics&width=400&height=400&seq=ilf3p1&orientation=squarish",
      },
      {
        id: "ilf3p2",
        name: "Dead Sea Salt Body Scrub Luxury Set",
        samplePrice: 62,
        bulkPrice: 22,
        moq: 20,
        category: "Dead Sea Minerals",
        image: "https://readdy.ai/api/search-image?query=Dead%20Sea%20salt%20body%20scrub%20luxury%20set%20premium%20skincare%20white%20background%20product%20photography%20elegant%20beauty%20Israel&width=400&height=400&seq=ilf3p2&orientation=squarish",
      },
      {
        id: "ilf3p3",
        name: "Anti-Aging Mineral Serum 30ml",
        samplePrice: 85,
        bulkPrice: 30,
        moq: 20,
        category: "Cosmetics",
        image: "https://readdy.ai/api/search-image?query=anti%20aging%20mineral%20serum%2030ml%20luxury%20skincare%20white%20background%20product%20photography%20premium%20beauty%20Israel%20Dead%20Sea&width=400&height=400&seq=ilf3p3&orientation=squarish",
      },
    ],
  },
  {
    id: "ilf4",
    name: "Negev Solar & Clean Energy Tech",
    city: "Beer Sheva",
    established: 2012,
    employees: "200–500",
    verified: true,
    dropshipping: false,
    rating: 4.8,
    responseRate: "95%",
    onTimeDelivery: "94%",
    productCount: 980,
    categories: ["Solar Energy", "Clean Tech", "Energy Storage"],
    description: "Cutting-edge solar and clean energy technology manufacturer in Beer Sheva — Israel's Silicon Wadi of the south. Producing high-efficiency solar panels, energy storage systems, and smart grid solutions for residential and commercial markets worldwide.",
    logo: "https://readdy.ai/api/search-image?query=solar%20clean%20energy%20company%20logo%20gold%20sun%20emblem%20white%20background%20Beer%20Sheva%20Israel%20technology%20corporate%20identity%20modern%20minimalist&width=80&height=80&seq=ilfl4&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Beer%20Sheva%20Israel%20solar%20clean%20energy%20factory%20production%20solar%20panels%20energy%20storage%20systems%20workers%20professional%20bright%20modern%20interior&width=800&height=400&seq=ilfc4&orientation=landscape",
    products: [
      {
        id: "ilf4p1",
        name: "High-Efficiency Solar Panel 400W Mono",
        samplePrice: 280,
        bulkPrice: 105,
        moq: 10,
        category: "Solar Energy",
        image: "https://readdy.ai/api/search-image?query=high%20efficiency%20solar%20panel%20400W%20monocrystalline%20white%20background%20product%20photography%20professional%20clean%20energy%20Israel%20technology&width=400&height=400&seq=ilf4p1&orientation=squarish",
      },
      {
        id: "ilf4p2",
        name: "Home Battery Storage System 10kWh",
        samplePrice: 1850,
        bulkPrice: 720,
        moq: 2,
        category: "Energy Storage",
        image: "https://readdy.ai/api/search-image?query=home%20battery%20storage%20system%2010kWh%20clean%20energy%20white%20background%20product%20photography%20professional%20technology%20Israel%20solar&width=400&height=400&seq=ilf4p2&orientation=squarish",
      },
      {
        id: "ilf4p3",
        name: "Smart Solar Inverter 5kW WiFi",
        samplePrice: 420,
        bulkPrice: 158,
        moq: 5,
        category: "Clean Tech",
        image: "https://readdy.ai/api/search-image?query=smart%20solar%20inverter%205kW%20WiFi%20clean%20energy%20device%20white%20background%20product%20photography%20professional%20technology%20Israel&width=400&height=400&seq=ilf4p3&orientation=squarish",
      },
    ],
  },
  {
    id: "ilf5",
    name: "Tel Aviv Cybersecurity Hardware",
    city: "Tel Aviv",
    established: 2015,
    employees: "100–200",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Israel", "USA", "UK", "Germany", "UAE", "Singapore"],
    rating: 4.8,
    responseRate: "96%",
    onTimeDelivery: "95%",
    productCount: 720,
    categories: ["Cybersecurity", "Hardware", "Network Security"],
    description: "Advanced cybersecurity hardware manufacturer in Tel Aviv — the world's cybersecurity capital. Producing enterprise-grade network security appliances, encrypted storage devices, and secure communication hardware for governments and corporations globally.",
    logo: "https://readdy.ai/api/search-image?query=cybersecurity%20hardware%20company%20logo%20gold%20shield%20circuit%20emblem%20white%20background%20Tel%20Aviv%20Israel%20technology%20corporate%20identity%20modern&width=80&height=80&seq=ilfl5&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Tel%20Aviv%20Israel%20cybersecurity%20hardware%20factory%20clean%20room%20production%20network%20security%20appliances%20workers%20professional%20bright%20modern%20interior&width=800&height=400&seq=ilfc5&orientation=landscape",
    products: [
      {
        id: "ilf5p1",
        name: "Enterprise Firewall Appliance 10Gbps",
        samplePrice: 1200,
        bulkPrice: 460,
        moq: 3,
        category: "Network Security",
        image: "https://readdy.ai/api/search-image?query=enterprise%20firewall%20appliance%2010Gbps%20network%20security%20hardware%20white%20background%20product%20photography%20professional%20technology%20Israel&width=400&height=400&seq=ilf5p1&orientation=squarish",
      },
      {
        id: "ilf5p2",
        name: "Encrypted USB Drive 256GB Military Grade",
        samplePrice: 145,
        bulkPrice: 54,
        moq: 20,
        category: "Hardware",
        image: "https://readdy.ai/api/search-image?query=encrypted%20USB%20drive%20256GB%20military%20grade%20security%20hardware%20white%20background%20product%20photography%20professional%20technology%20Israel&width=400&height=400&seq=ilf5p2&orientation=squarish",
      },
      {
        id: "ilf5p3",
        name: "Secure VPN Hardware Router",
        samplePrice: 380,
        bulkPrice: 142,
        moq: 5,
        category: "Cybersecurity",
        image: "https://readdy.ai/api/search-image?query=secure%20VPN%20hardware%20router%20network%20security%20device%20white%20background%20product%20photography%20professional%20technology%20Israel%20cybersecurity&width=400&height=400&seq=ilf5p3&orientation=squarish",
      },
    ],
  },
  {
    id: "ilf6",
    name: "Galilee Organic Foods & Olive Oil",
    city: "Nazareth",
    established: 2007,
    employees: "100–200",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Israel", "UAE", "USA", "UK", "Germany", "France", "Canada"],
    rating: 4.9,
    responseRate: "97%",
    onTimeDelivery: "96%",
    productCount: 580,
    categories: ["Organic Food", "Olive Oil", "Specialty Foods"],
    description: "Premium organic food and olive oil producer from the fertile Galilee region. Producing award-winning extra virgin olive oil, organic herbs, tahini, and specialty Mediterranean foods exported to gourmet retailers and dropshippers worldwide.",
    logo: "https://readdy.ai/api/search-image?query=organic%20olive%20oil%20food%20company%20logo%20gold%20olive%20branch%20emblem%20white%20background%20Galilee%20Israel%20food%20corporate%20identity%20elegant%20minimalist&width=80&height=80&seq=ilfl6&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Galilee%20Israel%20organic%20food%20olive%20oil%20production%20facility%20workers%20professional%20bright%20clean%20modern%20interior%20Mediterranean%20food&width=800&height=400&seq=ilfc6&orientation=landscape",
    products: [
      {
        id: "ilf6p1",
        name: "Extra Virgin Olive Oil Premium 5L",
        samplePrice: 65,
        bulkPrice: 24,
        moq: 20,
        category: "Olive Oil",
        image: "https://readdy.ai/api/search-image?query=extra%20virgin%20olive%20oil%20premium%205L%20luxury%20bottle%20white%20background%20product%20photography%20professional%20food%20Israel%20Galilee%20Mediterranean&width=400&height=400&seq=ilf6p1&orientation=squarish",
      },
      {
        id: "ilf6p2",
        name: "Organic Tahini Premium Jar 500g",
        samplePrice: 28,
        bulkPrice: 10,
        moq: 48,
        category: "Specialty Foods",
        image: "https://readdy.ai/api/search-image?query=organic%20tahini%20premium%20jar%20500g%20white%20background%20product%20photography%20professional%20food%20Israel%20Mediterranean%20specialty&width=400&height=400&seq=ilf6p2&orientation=squarish",
      },
      {
        id: "ilf6p3",
        name: "Galilee Herb & Spice Gift Set (8 jars)",
        samplePrice: 52,
        bulkPrice: 19,
        moq: 24,
        category: "Organic Food",
        image: "https://readdy.ai/api/search-image?query=Galilee%20herb%20spice%20gift%20set%208%20jars%20organic%20Mediterranean%20white%20background%20product%20photography%20premium%20food%20Israel&width=400&height=400&seq=ilf6p3&orientation=squarish",
      },
    ],
  },
];
